import { PatientNotesFormValues } from "./patient-notes-form.component";

export const formatPatientNoteToInput = (data: PatientNotesFormValues) => {
  return {
    id: data.id,
    title: data.title,
    description: data.description,
    patient: Number(data.patient?.value),
  };
};
